import { OvpVideoFormat } from "@sky-uk-ott/core-video-sdk-js";
import { getStreamFormat, getDrmConfig } from "./generateSessionConfig/browserConfig.js";
import { useMemo } from "react";
import { useEvent } from "../../lib/hooks/useEvent.js";
import { playoutDataCache } from "./playoutDataCache.js";
import { TestPresetTag } from "../../testStreamPreset.js";
import { useStable } from "../../lib/hooks/useStable.js";
const Noop = () => Promise.resolve();
const videoPlatformIntegrationProvider = {
  type: (
  /** @type {VideoPlatform} */
  "OVP"),

  async getLivePlayoutData(sessionKey) {
    return getPlayoutDataResponse(sessionKey, playoutDataCache.get(sessionKey));
  },
  async getVodPlayoutData(sessionKey) {
    return getPlayoutDataResponse(sessionKey, playoutDataCache.get(sessionKey));
  },
  sendHeartbeat: Noop,
  stopHeartbeat: Noop,
  decorateLicenseRequest: (req) => req
};
function getSettings(requestSigner, streamConfig, streamFormat) {
  if (TestPresetTag in streamConfig) {
    return void 0;
  }
  const { keyId, serviceKey } = streamConfig;
  const {
    transport,
    container,
    url,
    adCompatibility: { encodingProfile }
  } = streamConfig.assetByType[streamFormat];
  return {
    requestSigner,
    transport,
    container,
    url,
    keyId,
    serviceKey,
    adCompatibilityEncodingProfile: encodingProfile,
    adsEnabled: {
      preRollAdEnabled: typeof (streamConfig == null ? void 0 : streamConfig.adsEnabled) === "object" ? streamConfig.adsEnabled.preRollAdEnabled : false,
      midRollAdEnabled: typeof (streamConfig == null ? void 0 : streamConfig.adsEnabled) === "object" ? streamConfig.adsEnabled.midRollAdEnabled : false
    }
  };
}
function useVpiProvider({ signRequest, streamConfig }) {
  const requestSigner = useEvent(signRequest);
  const streamFormat = useMemo(getStreamFormat, []);
  const settings = useStable(getSettings(requestSigner, streamConfig, streamFormat));
  const sessionKey = useMemo(() => {
    if (settings) {
      const uuid = crypto.randomUUID();
      playoutDataCache.set(uuid, {
        ...settings
      });
      return uuid;
    }
    return "<test stream>";
  }, [settings]);
  return { sessionKey, vpiProvider: videoPlatformIntegrationProvider };
}
async function getPlayoutDataResponse(sessionKey, data) {
  if (!data) {
    throw new Error(`No playout data found for ${sessionKey}`);
  }
  const playoutData = getPlayoutData({
    ...data,
    drmConfig: await getDrmConfig(data)
  });
  return {
    statusCode: 200,
    ovpData: playoutData
  };
}
function toBooleanString(value) {
  return value ? "true" : "false";
}
function getPlayoutData({
  serviceKey,
  transport,
  container,
  url,
  adCompatibilityEncodingProfile,
  drmConfig,
  adsEnabled
}) {
  const result = {
    serviceKey,
    asset: {
      endpoints: [
      {
        url,
        cdn: "CDN 0"
      }],

      format: {
        transport,
        protection: drmConfig.ovpType,
        container,
        acodec: "AAC",
        vcodec: "H264"
      }
    },
    protection: {
      type: drmConfig.ovpType,
      licenceAcquisitionUrl: drmConfig.licenceAcquisitionUrl,
      certificateUrl: drmConfig.certificateUrl ?? "",
      licenceToken: "",
      deviceId: ""
    },
    videoFormat: OvpVideoFormat.UNKNOWN,
    thirdParties: {
      FREEWHEEL: {
        userId: "",
        contentId: serviceKey,
        adCompatibilityEncodingProfile
      }
    }
  };
  if (typeof adsEnabled === "object" && (adsEnabled.preRollAdEnabled || adsEnabled.midRollAdEnabled)) {
    result.adInstructions = {
      dai_PreRollEnabled: toBooleanString(adsEnabled == null ? void 0 : adsEnabled.preRollAdEnabled),
      dai_MidRollEnabled: toBooleanString(adsEnabled == null ? void 0 : adsEnabled.midRollAdEnabled)
    };
  }
  return result;
}
export {
  useVpiProvider };
//# sourceMappingURL=dist/components/CoreVideoPlayer/useVpiProvider.js.map